/*
  Reviews stage. Desktop shows three at once — previous, active, next — and
  moves by class, not by transform (motion confirms, never performs).
  Mobile is a native snap carousel; the dashes follow the scroll.
*/
(function () {
  'use strict';
  var desktop = window.matchMedia('(min-width: 990px)');

  function init(root) {
    if (root.dataset.psReady) return;
    root.dataset.psReady = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ps-rev]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ps-rev-go]'));
    var track = root.querySelector('[data-ps-revs-track]');
    var n = items.length, active = 0;

    function paint(i) {
      active = (i + n) % n;
      items.forEach(function (el, k) {
        el.classList.toggle('is-active', k === active);
        el.classList.toggle('is-prev', n > 2 && k === (active - 1 + n) % n);
        el.classList.toggle('is-next', n > 1 && k === (active + 1) % n);
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === active);
        if (k === active) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }

    function go(i) {
      if (desktop.matches) { paint(i); return; }
      var target = items[(i + n) % n];
      if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft - 16, behavior: 'smooth' });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.psRevGo, 10)); });
    });
    // clicking a dimmed neighbour brings it to the centre
    items.forEach(function (el, k) {
      el.addEventListener('click', function () {
        if (desktop.matches && !el.classList.contains('is-active')) paint(k);
      });
    });
    root.addEventListener('keydown', function (e) {
      if (!desktop.matches) return;
      if (e.key === 'ArrowRight') paint(active + 1);
      if (e.key === 'ArrowLeft') paint(active - 1);
    });

    track.addEventListener('scroll', function () {
      if (desktop.matches) return;
      var w = items[0] ? items[0].getBoundingClientRect().width + 16 : 1;
      var i = Math.round(track.scrollLeft / w);
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }, { passive: true });

    paint(0);
  }

  function boot() { document.querySelectorAll('[data-ps-revs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
